module.exports = __webpack_public_path__ + "images/help/icn-faq-mobile@2x-4c1808edcf8b34ab1c171c250e4127c6.png";